import { createClient } from '@oysterjs/core/graphql/client';
export const client = createClient('Agency');
